import { useTranslation } from 'react-i18next'

import { ArrowsLeftRightIcon, ArrowUDownLeftIcon } from '@phosphor-icons/react'

import { entityTypes } from '@/metrics/hooks/useMetrics/constants'
import useMetrics from '@/metrics/hooks/useMetrics/useMetrics'
import metricsServices from '@/metrics/services/services'
import { transactionTypes } from '@/returns/constants'

import ReasonsCard from '../ReasonsCard/ReasonsCard'
import ReturnSalesRatioCard from '../ReturnSalesRatioCard/ReturnSalesRatioCard'
import ReturnsAndExchangesRatioCard from '../ReturnsAndExchangesRatioCard/ReturnsAndExchangesRatioCard'
import * as Styles from './styles'

const VariantMetrics = ({
  variantId,
  returnPortalId,
  commonFilters,
  returnSalesRatioFilters,
  setReturnSalesRatioFilters,
  returnsAndExchangesRatioFilters,
  setReturnsAndExchangesRatioFilters,
  categoryId,
  typeId,
  collectionId,
  salesOrdersDataActivated,
}) => {
  const { t } = useTranslation()

  const getAdditionalFilters = (additionalFilters = {}) => ({
    ...additionalFilters,
    ...(collectionId && { collectionId }),
    ...(typeId && { typeId }),
    ...(categoryId && { categoryId }),
  })

  const { data: returnsAndExchangesRatioData, loading: loadingReturnsAndExchangesRatio } = useMetrics({
    returnPortalId,
    service: metricsServices.getVariantReturnsAndExchangesRatio,
    entityId: variantId,
    entityType: entityTypes.variant,
    filters: commonFilters,
    additionalFilters: getAdditionalFilters(returnsAndExchangesRatioFilters),
  })

  const { data: returnSalesRatioData, loading: loadingReturnSalesRatio } = useMetrics({
    returnPortalId,
    service: metricsServices.getVariantReturnsSalesRatio,
    entityId: variantId,
    entityType: entityTypes.variant,
    filters: commonFilters,
    additionalFilters: getAdditionalFilters(returnSalesRatioFilters),
    doRequest: !!salesOrdersDataActivated,
  })

  const { data: topReturnReasonsData, loading: loadingTopReturnReasons } = useMetrics({
    returnPortalId,
    service: metricsServices.getVariantTopReasons,
    entityId: variantId,
    entityType: entityTypes.variant,
    filters: commonFilters,
    additionalFilters: getAdditionalFilters({ transactionType: transactionTypes.refund }),
  })

  const { data: topExchangeReasonsData, loading: loadingTopExchangeReasons } = useMetrics({
    returnPortalId,
    service: metricsServices.getVariantTopReasons,
    entityId: variantId,
    entityType: entityTypes.variant,
    filters: commonFilters,
    additionalFilters: getAdditionalFilters({ transactionType: transactionTypes.exchange }),
  })

  return (
    <>
      <ReturnSalesRatioCard
        filters={{ ...commonFilters, ...returnSalesRatioFilters }}
        data={returnSalesRatioData}
        loading={loadingReturnSalesRatio}
        salesOrdersDataActivated={salesOrdersDataActivated}
        setChartFilters={setReturnSalesRatioFilters}
      />
      <ReturnsAndExchangesRatioCard
        data={returnsAndExchangesRatioData}
        loading={loadingReturnsAndExchangesRatio}
        filters={{ ...commonFilters, ...returnsAndExchangesRatioFilters }}
        setChartFilters={setReturnsAndExchangesRatioFilters}
      />
      <Styles.ColumnsContainer templateColumns={'1fr 1fr'}>
        <ReasonsCard
          title={t('Motivos de devolución')}
          icon={<ArrowUDownLeftIcon size={24} />}
          reasons={topReturnReasonsData?.results}
          reasonType={transactionTypes.refund}
          loading={loadingTopReturnReasons}
          shouldShowExport={false}
        />
        <ReasonsCard
          title={t('Motivos de cambio')}
          icon={<ArrowsLeftRightIcon size={24} />}
          reasons={topExchangeReasonsData?.results}
          reasonType={transactionTypes.exchange}
          loading={loadingTopExchangeReasons}
          shouldShowExport={false}
        />
      </Styles.ColumnsContainer>
    </>
  )
}

export default VariantMetrics
